module.exports = __webpack_public_path__ + "mo/img/swiper_bg05.6c75b42f.png";